import { useSearchParams } from "react-router-dom";
import CouponApplicabilityComponent from "../CouponApplicabilityComponent";
import CouponDetailsComponent from "../CouponDetailsComponent";
import CouponDiscountComponent from "../CouponDiscountComponent";
import CouponUsageComponent from "../CouponUsageComponent";
import StepperComponent from "../StepperComponent";

const CouponCreationComponent = () => {
  const [params, _setParams] = useSearchParams();
  const page_step = params.get("page_step");
  return (
    <div className="p-3 pt-0 bg-white w-full">
      <div className="p-5 border border-gray-100 rounded-xl shadow-sm sticky top-10 md:top-12 2xl:top-14 bg-white z-30">
        <p className="text-base font-bold text-[#1A1F36] tracking-tight">Coupon Setup</p>
        <StepperComponent />
      </div>

      <div>
        {page_step === "details_and_schedule" && <CouponDetailsComponent />}
        {page_step === "applicable_conditions" && <CouponApplicabilityComponent />}
        {page_step === "discount_page" && <CouponDiscountComponent />}
        {page_step === "usage_details" && <CouponUsageComponent />}
      </div>
    </div>
  );
};

export default CouponCreationComponent;
